import React from 'react';
import { Link } from 'react-router-dom';

const SurveyMyStore: React.FC = () => {
  return (
    <div className="space-y-16">
      {/* Hero Section */}
      <section className="text-center space-y-6">
        <h1 className="text-4xl font-bold">
          <span className="gradient-text">SurveyMyStore</span>
        </h1>
        <p className="text-slate-600 text-lg max-w-2xl mx-auto">
          Intelligent feedback collection platform that helps you improve 
          store ratings and customer satisfaction.
        </p>
      </section>

      {/* Features Grid */}
      <section className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {[
          {
            title: 'Smart Timing Engine',
            description: 'AI-powered algorithm determines the perfect moment to request feedback.',
            icon: '🎯'
          },
          {
            title: 'Custom Branding',
            description: "Fully customizable UI components that match your store's design.",
            icon: '🎨'
          },
          {
            title: 'Analytics Dashboard',
            description: 'Real-time insights into customer sentiment and feedback patterns.',
            icon: '📊'
          },
          {
            title: 'Multi-Platform SDK',
            description: 'Native support for web, mobile, and point-of-sale systems.',
            icon: '📱'
          },
          {
            title: 'Offline Support',
            description: 'Works seamlessly offline with automatic sync when connected.',
            icon: '🔄'
          },
          {
            title: 'Privacy First',
            description: 'GDPR compliant with minimal data collection by design.',
            icon: '🔒'
          }
        ].map((feature, i) => (
          <div key={i} className="glass-card group">
            <div className="text-4xl mb-4 group-hover:scale-110 transition-transform">
              {feature.icon}
            </div>
            <h3 className="text-xl font-semibold text-slate-900 mb-2">
              {feature.title}
            </h3>
            <p className="text-slate-600">
              {feature.description}
            </p>
          </div>
        ))}
      </section>

      {/* Integration Preview */}
      <section className="glass-card space-y-6">
        <h2 className="text-2xl font-bold text-slate-900">
          Simple Integration
        </h2>
        <div className="bg-slate-900 rounded-xl p-6 font-mono text-sm">
          <pre className="text-slate-300">
            <code>{`// Initialize SurveyMyStore
import SurveyMyStore from '@aecloudsystem/surveymystore';

const config = {
  storeId: 'your-store-id',
  triggerCount: 3,
  cooldownDays: 30
};

SurveyMyStore.initialize(config);

// Show feedback prompt
SurveyMyStore.showPrompt();`}</code>
          </pre>
        </div>
      </section>

      {/* CTA Section */}
      <section className="glass-card text-center space-y-6">
        <h2 className="text-3xl font-bold text-slate-900">
          Ready to Boost Your Store Ratings?
        </h2>
        <p className="text-slate-600 max-w-2xl mx-auto">
          Join thousands of businesses using SurveyMyStore to improve their 
          online presence and customer satisfaction.
        </p>
        <div className="flex items-center justify-center gap-4">
          <a href="mailto:sales@aecloudsystem.com" className="btn-primary">
            Request Demo
          </a>
          <Link to="/softwares/surveymystore/terms" className="btn-secondary">
            View Terms
          </Link>
        </div>
      </section>
    </div>
  );
};

export default SurveyMyStore;
